import { login, logout, session, changePassword } from '../../api';
import { i18n } from '../../i18n';
import moment from 'moment';
import router from '../../router';
import storage from '../../store/storage';

let checkSessionTimeout;

// Helper function to clear auth data from both state and storage
export const clearAuthData = ({ commit }) => {
	console.log('Clearing auth data from state and storage');

	// Clear from Vuex state
	commit('SAVE_AUTH_USER_TOKEN', null);
	commit('SET_AUTH_USER_TOKEN_LAST_CHECK', null);
	commit('SAVE_AUTH_USER', null);
	commit('SAVE_AUTH_USER_VENDOR', null);
	commit('SAVE_AUTH_LOGO', null);

	// Also clear from storage (cookies) to prevent restoring invalid token on next refresh
	try {
		const storedSession = storage.getItem('appSession');
		if (storedSession && storedSession.auth) {
			storedSession.auth.authUserToken = null;
			storedSession.auth.authUserTokenLastCheck = null;
			storedSession.auth.authUser = null;
			storedSession.auth.authUserVendor = null;
			storedSession.auth.logo = null;
			storage.setItem('appSession', storedSession);
			console.log('Cleared auth data from storage');
		}
	} catch (error) {
		console.warn('Error clearing auth data from storage:', error);
		// If there's an error, try removing the entire key as fallback
		try {
			storage.removeItem('appSession');
			console.log('Removed entire appSession from storage as fallback');
		} catch (removeError) {
			console.warn('Error removing appSession from storage:', removeError);
		}
	}
};

const setAuthData = (commit, data) => {
	const storedSession = { auth: {}};
	storedSession.auth.authUser = data.user;
	storedSession.auth.authUserToken = data.authToken;
	storedSession.auth.authUserVendor = data.vendor;
	storedSession.auth.logo = data.logo;
	commit('SAVE_AUTH_USER_TOKEN', data.authToken);
	commit('SAVE_AUTH_USER', data.user);
	commit('SAVE_AUTH_LOGO', data.logo);
	commit('SAVE_AUTH_USER_VENDOR', data.vendor);
	commit('SET_AUTH_USER_TOKEN_LAST_CHECK', false);
	storage.setItem('appSession', storedSession);
}

export const loginAction = async ({ commit, dispatch, state }, payload) => {
	// Clear any existing token before login to prevent using stale tokens
	// Clear from both Vuex state AND storage (cookies) to ensure old token is completely removed
	console.log('Clearing any existing token before login - removing from state and storage');
	dispatch('clearAuthData');
	let res = await login(payload);
	if (res) {
		setAuthData(commit, res.data);
		return true;
	}
};

export const logoutAction = async ({ commit }) => {

	console.log('logoutAction()');

	await logout();

	commit('SAVE_AUTH_USER_TOKEN', null);
	commit('SAVE_AUTH_LOGO', null);
	commit('SAVE_AUTH_USER', null);
	commit('SET_AUTH_USER_TOKEN_LAST_CHECK', null);

	return true;

};

export const forcedLogoutAction = async ({ dispatch }, showAlert) => {

	if (showAlert !== false) {

		await dispatch('showErrorAlert', i18n.t('fatalError.tokenExpired'));

	}

	await dispatch('logoutAction');

	// Prevent adding redirect parameter if already on login page
	const currentPath = router.currentRoute.fullPath;
	const isOnLoginPage = currentPath === '/auth/login' || currentPath === '/login';

	// Only navigate if not already on login page
	if (!isOnLoginPage) {
		await router.push({
			name: 'Login',
			query: (currentPath !== '/') ? {redirect: encodeURI(currentPath)} : {}
		});
	}

	return true;

};

const isTokenValid = async () => {
	let result = await session();
	if (!result) {
		return false;
	}
	return result;

};

export const checkAuthUserToken = async ({ commit, dispatch }) => {
	const appSession = storage.getItem('appSession');
	let parsedSession;
	try {
		parsedSession = JSON.parse(appSession);
	} catch {
		parsedSession = appSession;
	}
	const state = parsedSession?.auth ?? {};
	if (!state.authUserToken) {
		console.log('state.authUserToken not found');
		return false;
	}
	let alreadyLoggedOut = false;
	let now = moment();
	let xMinAfterLastCheck = moment(state.authUserTokenLastCheck).add(2, 'minutes');
	if (!state.authUserTokenLastCheck || now.isSameOrAfter(xMinAfterLastCheck)) {
		let result = await isTokenValid().catch(error => {
			console.debug('isTokenValid error', JSON.stringify(error, null, 2));
			if (error.response && error.response.status === 403) {
				alreadyLoggedOut = true;
			}
		});
		if (!result) {
			console.log('Token validation failed - clearing invalid token from state and storage');
			// Clear the invalid token from both state and storage immediately
			dispatch('clearAuthData');
			if (!alreadyLoggedOut) {
				console.debug('isTokenValid forcedLogoutAction');
				// Note: forcedLogoutAction will also clear state, but we've already done it above
				// to ensure storage is also cleared
				dispatch('forcedLogoutAction', false); // Don't show alert on auto-logout
			}
			return false;
		}
		const newData = {authToken: state.authUserToken, vendor: state.authUserVendor, logo: state.logo};
		if (result.Item) {
			newData.user = result.Item.user;
		}
		setAuthData(commit, newData)
	}
	if (!checkSessionTimeout) {
		checkSessionTimeout = setTimeout(() => {
			checkSessionTimeout = null;
			dispatch('checkAuthUserToken');
		}, 1000 * 60 * 4);
	}
	return (state.authUserToken);

};

export const changePasswordAction = async ({ commit }, payload) => {

	let res = await changePassword(payload);

	if (res) {

		return res;

	}

};
